import { CheckCircleRounded } from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { navigate } from "@reach/router";
import * as React from "react";
import { useEffect } from "react";
import { CurrencyFormat } from "./currencyformatter";
import { Reciept } from "./transactions/reciept";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
}));

export default function SuccessPage({ location }) {
  const {
    mode,
    transaction_type,
    amount,
    accountnumber,
    fullname,
    date,
    uid,
  } = location.state;

  const to = mode === "international" ? fullname : accountnumber;

  useEffect(() => {
    console.log(location.state);
  }, []);
  return (
    <>
      <Reciept data={location.state} />
      <Stack
        pt={2}
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <Button
          disableElevation
          variant="contained"
          color="primary"
          onClick={() => {
            navigate("account");
          }}
        >
          To account
        </Button>
      </Stack>
    </>
  );
}
